__webpack_require__.p = "https://static.fotor.com/app/face-mimic/";